import React from 'react'
import DOMPurify from 'dompurify'
import './rendergutenberg.css'

const RenderGutenberg = ({ content }) => {
    if (!content) return null;

    // Clean the content
    const clean = DOMPurify.sanitize(content, {
        ALLOWED_TAGS: [
            'p', 'br', 'strong', 'em', 'u', 'i', 'b', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
            'ul', 'ol', 'li', 'a', 'img', 'figure', 'figcaption', 'div', 'span',
            'blockquote', 'hr', 'table', 'thead', 'tbody', 'tr', 'th', 'td',
            'section', 'article', 'header', 'footer', 'main', 'nav'
        ],
        ALLOWED_ATTR: [
            'href', 'target', 'rel', 'src', 'alt', 'class', 'id', 'style',
            'width', 'height', 'loading', 'decoding', 'sizes', 'srcset',
            'title', 'aria-label', 'role'
        ]
    });

    return (
        <div className="gutenberg-content">
            <div dangerouslySetInnerHTML={{ __html: clean }} />
        </div>
    )
}

export default RenderGutenberg